import {Component, Inject, OnInit, TemplateRef, ViewChild, ViewContainerRef} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Globals} from '../../../../../../globals';
import {DiagnosisService} from '../../../../../../services/form/diagnosis.service';
import {PatientCaseWorkItemFormDataModel} from '../../../../../../models/forms/data/patient-case-work-item-form-data.model';
import { DataPatientCaseWorkItemModel } from 'src/app/models/accountsReceivable/data-patient-case-work-item.model';
import { ITdoTreeItem } from 'src/app/tdo-controls/common/tdo-tree/models/i-tdo-tree-item';
import { IoTreeNodeModel } from 'src/app/modules/imaging/models/io-tree-node.model';
import { EnumValidValueItemModel } from 'src/app/models/enum/enum-valid-value-item.model';
import { StaticDataService } from 'src/app/services/static-data.service';
import { fromEvent, Subscription } from 'rxjs';
import { ToothConfigurationModel } from 'src/app/models/teeth/tooth-configuration.model';
import { DataPatientCaseModel } from 'src/app/models/accountsReceivable/data-patient-case.model';
import { FormsGlobals } from 'src/app/models/forms/forms.enum';
import {Overlay, OverlayRef} from '@angular/cdk/overlay';
import { TemplatePortal } from '@angular/cdk/portal';
import { filter, take } from 'rxjs/operators';
import { DentalXChangeRTBRequestModel } from 'src/app/models/accountsReceivable/dentalxchange-rtb-request.model';

@Component({
  selector: 'app-diagnosis-clone-dialog',
  templateUrl: './diagnosis-clone-dialog.component.html',
  styleUrls: ['./diagnosis-clone-dialog.component.scss']
})
export class DiagnosisCloneDialogComponent implements OnInit {
  private sourceDiagnosisId: string;
  forms: PatientCaseWorkItemFormDataModel[] = [];
  selectedForm: PatientCaseWorkItemFormDataModel;
  selectedForms: PatientCaseWorkItemFormDataModel[] = [];
  selectedSourceForm: PatientCaseWorkItemFormDataModel;
  caseWorkItemList: DataPatientCaseModel[]=[];
  caseStatusEnums: EnumValidValueItemModel[] = [];
  FormStatusEnums: EnumValidValueItemModel[] = [];
  cfgTeeth: ToothConfigurationModel[] = [];
  validValueSubscription: Subscription;
  private overlayRef: OverlayRef | null;
  private sub: Subscription;

  @ViewChild('lectureContextMenu') lectureContextTemplate: TemplateRef<any>;

  constructor(private dialogRef: MatDialogRef<DiagnosisCloneDialogComponent>,
              private globals: Globals,
              @Inject(MAT_DIALOG_DATA) private data: any,
              private diagnosisService: DiagnosisService,
              private staticDataService: StaticDataService,
              private formsGlobals: FormsGlobals,
              private overlay: Overlay,
              private viewContainerRef: ViewContainerRef,) {
    this.sourceDiagnosisId = data.sourceDiagnosisId;
    this.forms = data.sourceForms;
  }

  async ngOnInit(): Promise<void> {
    if (this.staticDataService.isReady) {
      this.setupEnums();
    } else {
      if (!this.validValueSubscription) {
        this.validValueSubscription = this.staticDataService.validValuesReadyEvent.subscribe({
          complete: () => {
            this.setupEnums();
          }
        });
        this.staticDataService.refreshValues(true, false, false);
      }
    }

    await this.diagnosisService.getDiagnosisFormsForPatient(this.globals.currentPatientId).subscribe((result) => {
      this.caseWorkItemList = result;
      const matchedForms = this.caseWorkItemList.flatMap(caseWorkItem =>
        caseWorkItem.dataPatientCaseWorkItems?.flatMap(workItem =>
          workItem.dataPatientCaseWorkItemForms?.filter(form => form.CaseWorkItemFormsId === this.sourceDiagnosisId) || []
        ) || []
      );
      this.selectedSourceForm = matchedForms[0];
    });
  }

  setupEnums() {
    this.caseStatusEnums = this.staticDataService.getValidValueItemsByValidValueName('enumCaseStatus');
    this.FormStatusEnums = this.staticDataService.getValidValueItemsByValidValueName('enumFormCompletionStatus');
  }

  isItemSelected(item: PatientCaseWorkItemFormDataModel): boolean {
    if(this.selectedForms.findIndex(p => p.CaseWorkItemFormsId === item.CaseWorkItemFormsId) > -1){
      return true;
    }
    return false;
  }

  isSource(item: PatientCaseWorkItemFormDataModel): boolean {
    return this.selectedSourceForm === item;
  }

  onEndoDiagnosisContext(event: MouseEvent, item: any) {
    this.openContext(event, this.lectureContextTemplate, item);
  }

  selectedSource(data: any) {
    this.selectedSourceForm = data;
  }

  openContext({x, y}: MouseEvent, template: TemplateRef<any>, data: any, data1: any = null, closeOnItemClick = true): void {

    this.closeContext();
    x = x + 100;
    y = y - 10;
    const positionStrategy = this.overlay.position().flexibleConnectedTo({x, y}).withPositions([
      {
        originX: 'end',
        originY: 'bottom',
        overlayX: 'end',
        overlayY: 'top'
      }
    ]);

    this.overlayRef = this.overlay.create({
      positionStrategy,
      scrollStrategy: this.overlay.scrollStrategies.close()
    });

    this.overlayRef.attach(new TemplatePortal(template, this.viewContainerRef, {$implicit: data, data1}));

    this.sub = fromEvent<MouseEvent>(document, 'click')
      .pipe(
        filter(event => {
          if (closeOnItemClick) {
            this.closeContext();
          } else {
            const clickTarget = event.target as HTMLElement;
            return !!this.overlayRef && !this.overlayRef.overlayElement.contains(clickTarget);
          }
        }), take(1)).subscribe(() => this.closeContext());
  }

  closeContext(): void {
    this.sub !== undefined && this.sub.unsubscribe();
    if (this.overlayRef) {
      this.overlayRef.dispose();
      this.overlayRef = null;
    }
  }

  onCaseItemClick(item: PatientCaseWorkItemFormDataModel ){
    if ((item.enumFormCompletionStatusID !== this.formsGlobals.STATUS_COMPLETED || item.enumFormCompletionStatusID  === this.formsGlobals.STATUS_COMPLETEDANDSIGNED) && item.CaseWorkItemFormsId !== this.selectedSourceForm.CaseWorkItemFormsId) {
      if(this.selectedForms.findIndex(p => p.CaseWorkItemFormsId === item.CaseWorkItemFormsId) > -1){
        this.selectedForms = this.selectedForms.filter(p => p.CaseWorkItemFormsId !== item.CaseWorkItemFormsId);
      }else{
        this.selectedForms.push(item);
   }
  }
}

  onCancelClick() {
    this.dialogRef.close();
  }

  onOkClick() {
    this.diagnosisService.cloneDiagnosis(this.selectedSourceForm.CaseWorkItemFormsId, this.selectedForms).subscribe(() => {
      this.dialogRef.close();
    });
  }


  getTitle(item: DataPatientCaseWorkItemModel){
    const statusDate = new Date(item.StatusOn);
    return item.Description + ' - ' + this.getStatus(item.enumCaseWorkItemStatusID) + ' - ' + statusDate.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' });
  }

  getStatus(enumCaseStatusID: string) {
    if (this.caseStatusEnums) {
      if (enumCaseStatusID) {
        const enu = this.caseStatusEnums.find(p => p.ValidValueItemId.toLowerCase() === enumCaseStatusID.toLowerCase());
        if (enu) {
          return enu.ItemDisplayValue;
        } else {
          return this.caseStatusEnums[0]?.ItemDisplayValue;
        }
      } else {
        return this.caseStatusEnums[0]?.ItemDisplayValue;
      }
    }
  }

  getFormStatus(enumFormStatus: string) {
    if (this.FormStatusEnums) {
      if (enumFormStatus) {
        const enu = this.FormStatusEnums.find(p => p.ValidValueItemId.toLowerCase() === enumFormStatus.toLowerCase());
        if (enu) {
          return enu.ItemDisplayValue;
        } else {
          return this.FormStatusEnums[0]?.ItemDisplayValue;
        }
      } else {
        return this.FormStatusEnums[0]?.ItemDisplayValue;
      }
    }
  }

  onSelect(form: PatientCaseWorkItemFormDataModel) {
    this.selectedForm = form;
  }

  getToothNum(i: ToothConfigurationModel) {
    const cfg = this.cfgTeeth.find(p => p.ToothId.toLowerCase() === i.ToothId.toLowerCase());
    if (cfg) {
      return cfg.cfgToothDescriptions[0].Notation;
    }
  }
}
